import { Box, Typography, useTheme } from "@mui/material";
import { ArrowRightIcon } from "request-form-lib";

export type SimpleNavigationMobileHeadlineProps = {
    headline?: string;
    onExit?: () => void;
};

const CONTENT_MAX_WIDTH = 1320;
const MOBILE_PADDING = "10px";

const mobileHeadlineSx = {
    color: "#000",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: '"Juli Sans", Juli, sans-serif',
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
} as const;

const SimpleNavigationMobileHeadline = ({
    headline,
    onExit,
}: SimpleNavigationMobileHeadlineProps) => {
    const theme = useTheme();

    return (
        <Box
            component="button"
            type="button"
            onClick={onExit}
            sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                gap: 0,
                width: "100%",
                maxWidth: CONTENT_MAX_WIDTH,
                marginX: "auto",
                padding: MOBILE_PADDING,
                boxSizing: "border-box",
                border: "none",
                backgroundColor: theme.palette.background.default,
                cursor: "pointer",
                textAlign: "left",
            }}
        >
            <Box
                sx={{
                    width: 48,
                    height: 48,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                }}
            >
                <Box
                    component="span"
                    sx={{
                        display: "inline-flex",
                        lineHeight: 0,
                        transform: "rotate(180deg)",
                    }}
                >
                    <ArrowRightIcon width={16} height={16} color="#000" />
                </Box>
            </Box>
            <Typography component="span" sx={mobileHeadlineSx}>
                {headline}
            </Typography>
        </Box>
    );
};

export default SimpleNavigationMobileHeadline;
